<template>
  <el-drawer :title="weChatDrawer.title" :visible.sync="weChatDrawer.visible" direction="rtl"
    custom-class="drawer-right-side">
    <div class="drawer-form">
      <el-form :model="weChatForm" :rules="weChatFormRules" ref="weChatForm" label-width="100px" label-position="left"
        class="demo-weChatForm">
        <el-form-item label="微信号" prop="wx_num">
          <el-input v-model="weChatForm.wx_num"></el-input>
        </el-form-item>
        <!-- <el-form-item label="坐席" prop="phone">
                <el-input v-model="weChatForm.phone"></el-input>
            </el-form-item> -->
        <el-form-item>
          <el-button type="primary" @click="saveweChatDrawer">保存</el-button>
        </el-form-item>
      </el-form>
    </div>
  </el-drawer>
</template>

<script>
export default {
  data() {
    return {
      weChatDrawer: {
        title: '绑定微信号',
        visible: false
      },
      weChatForm: {
        id: '',
        wx_num: ''
      },
      weChatFormRules: {
        wx_num: [{
          required: true,
          message: '请输入微信号',
          trigger: 'blur'
        },
        ]
      }
    };
  },
  methods: {
    getWeChat(id) {
      let _this = this;
      let url = '/api/ucenter.user/selectWxNum';
      let apiParams = {
        id: id,
      };
      this.$post(url, apiParams).then(function (res) {
          if(res.code ==200){
            let num = res.data.wx_num
            _this.weChatForm.wx_num= num;
          } else {
            _this.weChatForm.wx_num =''
          }
      });
    },
    // 显示抽屉
    showweChatDrawer(row) {
      let _this = this;
      _this.weChatDrawer.visible = true;
      _this.weChatForm.id = row.id;
      _this.getWeChat(row.id)
    },
    // 保存绑定手机号
    saveweChatDrawer() {
      let that = this;
      that.$refs['weChatForm'].validate((valid) => {
        if (valid) {
          let url = '/api/ucenter.user/bindWxNum';
          let query = that.weChatForm;
          that.$post(url, query).then(function (res) {
            if (res.code == 200) {
              that.$message.success(res.msg);
              that.weChatDrawer.visible = false;
              that.$emit('getTableData');
            } else {
              that.$message.error(res.msg);
            }
          });
        } else {
          that.$message.warning('请填写完整并检查您的填写信息');
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
@import url('@/assets/css/drawer.less');
.demo-weChatForm {
    padding: 0 32px;
}
</style>
